import { axiosInstance } from '../common/api';

export const changePassword = (data) => {
  const url = `/auth/password`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
